import { render, staticRenderFns } from "./CoachLesson.vue?vue&type=template&id=225537e8&"
import script from "./CoachLesson.vue?vue&type=script&lang=js&"
export * from "./CoachLesson.vue?vue&type=script&lang=js&"
import style0 from "./CoachLesson.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CoachLesson.vue"
export default component.exports